import React from 'react';


export default class TodoApp extends React.Component {
    constructor(props) {
      super(props);
      this.state = { items: [], text: '' };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
      return (
        <div className="jingtext">
          <h3>经咒记录</h3>
          <TodoList items={this.state.items} />
          <form onSubmit={this.handleSubmit}>
            <label htmlFor="new-todo">
             您可以输入本次所持经咒
            </label>
            <br/>
            <input
              id="new-todo"
              onChange={this.handleChange}
              value={this.state.text}
            />
            <br/>
            <button>
              点击添加第{this.state.items.length + 1}条
            </button>
          </form>
          <br/>
          <br/>
          <h3>参考经咒</h3>
          <p style={{textIndent:'2em'}}>观自在菩萨，行深般若波罗蜜多时，照见五蕴皆空，渡一切苦厄。

舍利子！色不异空，空不异色；色即是空，空即是色；受想行识，亦复如是。

舍利子！是诸法空相，不生不灭，不垢不净，不增不减。

是故空中无色，无受想行识，无眼耳鼻舌身意，无色声香味触法，无眼界，乃至无意识界。

无无明，亦无无明尽，乃至无老死，亦无老死尽，无苦集灭道。无智亦无得。

以无所得故，菩提萨埵，依般若波罗蜜多故，心无罣碍，无罣碍故，无有恐怖， 远离颠倒梦想，究竟涅槃。

三世诸佛，依般若波罗蜜多故，得阿耨多罗三藐三菩提。

故知般若波罗蜜多，是大神咒，是大明咒，是无上咒，是无等等咒，能除一切苦，真实不虚。

故说般若波罗蜜多咒，即说咒曰︰揭諦揭諦，波罗揭諦，波罗僧揭諦，菩提娑婆呵。</p>
          <br/>
          <br/>
          <br/>
          <br/>
          <center>
          <h2>回向偈</h2>
          <p>诵经功德殊胜行,无边胜福皆回向。</p><p>普愿沉溺诸众生,速往无量光佛刹。</p><p>
十方三世一切佛,一切菩萨摩诃萨,摩诃般若波罗密。</p>
</center>
        </div>
        
      );
    }
  
    handleChange(e) {
      this.setState({ text: e.target.value });
    }
  
    handleSubmit(e) {
      e.preventDefault();
      if (this.state.text.length === 0) {
        return;
      }
      const newItem = {
        text: this.state.text,
        id: Date.now()
      };
      this.setState(state => ({
        items: state.items.concat(newItem),
        text: ''
      }));
    }
  }
  
class TodoList extends React.Component {
    render() {
      return (
        <ul>
          {this.props.items.map(item => (
            <li key={item.id}>{item.text}</li>
          ))}
        </ul>
      );
    }
  }
  
